import { changeTermsAgreement } from '@/api/api.terms';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useTermsQuery from './useTermsQuery';
import { produce } from 'immer';
import { TermsResponse } from '../../api/terms.types';

const useTermsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: getMutationKey(),
    mutationFn: changeTermsAgreement,
    onSuccess: (_, variables) => {
      queryClient.setQueryData<TermsResponse>(
        useTermsQuery.getQueryKey(),
        produce((draft) => {
          if (!draft) return;

          draft.terms = variables;
        }),
      );
    },
  });
};

const getMutationKey = () => ['change-terms-agreement'];
useTermsMutation.getMutationKey = getMutationKey;

export default useTermsMutation;
